export const DEFAULT_TXT_SPLIT_PANE_HEIGHT = 520;

export const txtSplitColumnSx = {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
} as const;

export const txtSplitHeaderSx = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
    mb: 1,
    minHeight: 40,
    flexShrink: 0,
} as const;

export function createTxtSplitPaneSx(paneHeight: number) {
    return {
        flex: 1,
        minHeight: paneHeight,
        maxHeight: paneHeight,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    } as const;
}

export const txtSplitHtmlFieldSx = {
    flex: 1,
    minHeight: 0,
    '& .MuiInputBase-root': {
        height: '100%',
        alignItems: 'stretch',
    },
    '& .MuiInputBase-input': {
        height: '100% !important',
        overflow: 'auto !important',
        boxSizing: 'border-box',
        fontFamily: 'monospace',
        fontSize: '0.8rem',
    },
} as const;

export const txtSplitHtmlSourceStackSx = {
    flex: 1,
    minHeight: 0,
    display: 'grid',
    gridTemplate: '1fr / 1fr',
    position: 'relative',
} as const;
